module.exports = __webpack_public_path__ + "img/dg.c319d7b0.png";